// Author    : Dimitri Sabadie <dimitri.sabadie@sculpteo.com>
// Copyright : (C) 2015 Sculpteo
//
// This file exports several utility functions one can use to perform fast bit packing / unpacking.

/* This function takes a 32 bit value and converts it into a 8 bit RGBA tuple.
 * Can be used to pass a 32 bit value to a shader as a colour, for instance.
 *
 * The following law stands:
 *
 *   unpackRGBA8(packRGBA8(x)) == x
 *
 * */
packRGBA8 = function (x) {
  return [(x >> 24) & 0xff, (x >> 16) & 0xff, (x >> 8) & 0xff, x & 0xff];
};

/* This function takes a 8 bit RGBA tuple and converts it into a 32 bit value.
 * Can be used to retrieve 32 bit value from a RGBA texture.
 *
 * The following law stands:
 *
 *   packRGBA8(unpackRGBA8(x)) == x
 *
 */
unpackRGBA8 = function (rgba) {
  return (rgba[0] << 24) + (rgba[1] << 16) + (rgba[2] << 8) + rgba[3];
};
